module.exports = __webpack_public_path__ + "img/box_all.0c1bc0f3.png";